import { DeploymentProcessEditorPage, type DeploymentProcessEditorPageProps } from "./DeploymentProcessEditorPage";
export type BranchDeploymentProcessEditorPageProps = DeploymentProcessEditorPageProps;
export function BranchDeploymentProcessEditorPage(props: BranchDeploymentProcessEditorPageProps) {
    return <DeploymentProcessEditorPage {...props}/>;
}
